// 출퇴근 요약(일자별 플랫 배열)을 사람(employee_id) 단위로 그룹핑하는 공용 유틸.
// AttendanceInfo.js(내부)와 AttendancePublicPage.js(공개)가 동일 계약으로 공유한다.
// 백엔드 /summary 계약은 일자별 플랫 배열로 불변 — 사람별 집계는 프론트에서 수행한다.
//
// 집계 규칙(스펙 [v2]):
//  - work_days           = 해당 직원의 일자별 응답 행 개수
//  - total_work_minutes  = work_minutes가 null이 아닌 행의 합(전부 null이면 0)
//  - has_work_minutes    = work_minutes가 null이 아닌 행이 하나라도 있으면 true(전부 null이면 '-' 렌더용)
//  - 자식(details)        = 그 직원의 일자별 행, work_date DESC 정렬
//  - 부모(그룹) 정렬       = name ASC
//
// 주의: antd Table의 기본 childrenColumnName은 'children'이라 그 키를 쓰면 트리 모드로 오인된다.
//       expandable로 직접 렌더하기 위해 자식 배열은 'details' 키에 담는다.

export function groupByEmployee(rows) {
  if (!Array.isArray(rows)) return [];

  const map = new Map();
  for (const row of rows) {
    const key = row.employee_id;
    if (!map.has(key)) {
      map.set(key, {
        employee_id: row.employee_id,
        user_no: row.user_no,
        name: row.name,
        employment_type: row.employment_type,
        vendor_name: row.vendor_name,
        department: row.department,
        position: row.position,
        details: [],
      });
    }
    map.get(key).details.push(row);
  }

  const groups = Array.from(map.values());
  for (const g of groups) {
    // 일자별 상세: work_date DESC
    g.details.sort((a, b) => String(b.work_date || '').localeCompare(String(a.work_date || '')));
    g.work_days = g.details.length;
    g.has_work_minutes = g.details.some((r) => r.work_minutes != null);
    g.total_work_minutes = g.details.reduce(
      (sum, r) => sum + (r.work_minutes != null ? r.work_minutes : 0),
      0,
    );
  }

  // 사람 정렬: name ASC
  groups.sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')));
  return groups;
}

export default groupByEmployee;
